import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function currencies(state=initialState.currencies, action) {
    switch (action.type) {
        case appConstants.CURRENCY_SUCCESS:
            return action.currencies;
        default:
            return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/currency.reducer.js